import { jsx as _jsx } from "react/jsx-runtime";
import { BatteryBody, BatteryCore, BatteryIndicator } from './styled';
export default function BatteryUnit({ percents, }) {
    return (_jsx(BatteryBody, { children: _jsx(BatteryCore, { children: _jsx(BatteryIndicator, { percents: percents }) }) }));
}
